import { ensureLength } from '@/lib/utils';

export const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const daysPerMonth = [
	31,
	28,
	31,
	30,
	31,
	30,
	31,
	31,
	30,
	31,
	30,
	31
];

export const getDaysInMonth = ( month, year ) => {
	const numberOfDays = daysPerMonth[month];

	if ( month === 1 ) { // February
		// leap years are every four years unless the year
		// is perfectly divisible by 100. If the year is evenly
		// divisible by 400 then it is still a leap year even
		// though it is evenly divisible by 100.
		const isLeapYear = ( year % 4 === 0 ) && ( ( year % 100 !== 0 ) || ( year % 400 === 0 ) );

		if ( isLeapYear ) {
			return numberOfDays + 1;
		}
	}

	return numberOfDays;
};

export const getLastMonth = ( month, year ) => {
	const lastMonth = month - 1;

	if ( lastMonth < 0 ) {

		return {
			month : 11,
			year  : year - 1,
		};
	}

	return {
		month : lastMonth,
		year,
	};
};

export const getNextMonth = ( month, year ) => {
	const nextMonth = month + 1;

	if ( nextMonth > 11 ) {

		return {
			month : 0,
			year  : year + 1,
		};
	}

	return {
		month : nextMonth,
		year,
	};
};

export const timeOf = ( unix ) => {
	const day = new Date( unix );

	const HH = ensureLength( day.getHours(), 2 );
	const MM = ensureLength( day.getMinutes(), 2 );
	const SS = ensureLength( day.getSeconds(), 2 );

	return `${HH}:${MM}:${SS}`;
};

export const dateOf = ( unix, includeTime ) => { // eslint-disable-line
	const day = new Date( unix );

	const mm   = months[day.getUTCMonth()];
	const dd   = day.getUTCDate();
	const yyyy = day.getUTCFullYear();

	if ( window.isNaN( dd ) ) { // eslint-disable-line
		return '-';
	}

	const date = `${mm} ${dd}, ${yyyy}`;

	if ( includeTime ) {
		const time = timeOf( unix );

		return `${date} ${time}`;
	}

	return date;
};

export default {
	months,
};
